import axios from "axios";
import { FC, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BarLoader } from "react-spinners";
import { ClearTokens, HasToken, GotoSSO, GoToRedirectPage } from "./components/SsoComponent";
import Endpoints from "../../enums/Endpoints";


const Login: FC = () => {
    const [message, setMessage] = useState<string>('Girişe');
    const [searchParams] = useSearchParams();
    const token = searchParams.get("code");

    useEffect(() => {
        if (token !== null) {
            if (localStorage.getItem("initialUrl"))
                setMessage('İlgili sayfaya');
            else
                setMessage('Ana sayfaya');

            localStorage.setItem("ssotoken", token);
            axios({
                method: 'POST',
                url: `${process.env.REACT_APP_API_LINK}/${Endpoints.SsoAuthorization}?code=${token}`,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                if (response.status === 200) {
                    localStorage.setItem("token", response.data.access_token);
                    const expires = response.data.expires_in;
                    const now = new Date(Date.now());
                    now.setTime(now.getTime() + (expires * 1000));
                    localStorage.setItem("tokenExpire", now.toString());
                    GoToRedirectPage();
                }
                else {
                    ClearTokens();
                    if (!HasToken())
                        GotoSSO();
                }
            }).catch(function (e) {
                if (e.response.status === 404)
                    window.location.href = '/error/authority';
                else {
                    ClearTokens();
                    if (!HasToken())
                        GotoSSO();
                }
            });
        } else {
            ClearTokens();
            if (!HasToken())
                GotoSSO();
        }
    }, []);

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
            <div className="sweet-loading" style={{ textAlign: 'center' }}>
                <div>
                    <img src="/media/logos/yanmenu.png" alt="Logo" className='img-fluid' />
                </div>

                <div className='mt-20'>
                    <span style={{ fontSize: '24px' }}>{message} yönlendiriliyorsunuz, lütfen bekleyin...</span>
                </div>

                <div className='mt-10'>
                    <BarLoader color="#000787" loading={true} cssOverride={{
                        display: "block",
                        margin: "0 auto",
                        borderColor: "gray"
                    }} />
                </div >
            </div >
        </div >
    )
}

export { Login }